/* eslint-disable import/prefer-default-export, no-param-reassign, no-undef */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import app from './modules/app';
import user from './modules/user';
import invoice from './modules/invoice';
import splitting from './modules/splitting';
import settings from './modules/settings';
import { storeApiPlugin } from '../services/api';

Vue.use(Vuex);

const requestIdleCallback =
  window.requestIdleCallback ||
  ((cb) => {
    const start = Date.now();
    return setTimeout(() => {
      const data = {
        didTimeout: false,
        timeRemaining() {
          return Math.max(0, 50 - (Date.now() - start));
        },
      };
      cb(data);
    }, 1);
  });

const vuePersist = {
  reducer: (state) => ({
    user: {
      isLoggedIn: state.user.isLoggedIn,
      user: state.user.user,
      tokens: state.user.tokens,
    },
    app: {
      drawer: state.app.drawer,
    },
  }),
  setState: (key, state, storage) => {
    requestIdleCallback(() => {
      storage.setItem(key, JSON.stringify(state));
    });
  },
};

const store = new Vuex.Store({
  modules: {
    app,
    user,
    invoice,
    splitting,
    settings,
  },
  plugins: [createPersistedState(vuePersist), storeApiPlugin],
});

export default store;
